const menyer = [
  {
    id: 1,
    namn: "standard",
    mat: function () {
      return (
        <>
          <h3>Skärgårdstallrik</h3>
          Varmrökt lax, gubbröra, 3 sorters sill, gräddfil med gräslök,
          gubbröra, färskpotatis, västerbottenpaj, rågbröd, knäckebröd och smör
          – 225 kr

          <h3>Silltallrik</h3>3 sorters sill, gräddfil med gräslök, gubbröra,
          ägg, potatis, västerbottenpaj, rågbröd, knäckebröd och smör – 159 kr

          <h3>Paj med sallad</h3>
          Lax och spenat - 125kr
          <br />
          Fetaost och spenat - 125 kr

          <h3>Lasagne</h3>
          Serveras med sallad<br />
          Bolognese - 145 kr<br />
          Vegetarisk - 145 kr

          <h3>Smörrebröd</h3>
          <br />
          Kallrökt lax med citronkräm – 99 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr
          <br />
          Chevré, valnötter och honung - 109 kr

          <h3>Räksmörgås</h3>
          Handskalade stora räkor på rågbröd – 159 kr

          <h3>Våffla </h3>
          med grädde och sylt – 65 kr
          {/*
          <h3>Pannkakor</h3>
          med sylt och grädde, 2 eller 3 st. – 70/90 kr
          */}
        </>
      );
    },
  },
  {
    id: 2,
    namn: "start",
    mat: function () {
      return (
        <>

          {/*
          <h3>Varmrökt lax med romsås</h3>färskpotatis och sallad – 209 kr
        */}

          <h3>Silltallrik</h3>3 sorters sill, gräddfil med gräslök, gubbröra,
          ägg, potatis, västerbottenpaj, rågbröd, knäckebröd och smör – 165 kr
          {/*
          <h3>Husets köttbullar</h3>
          med potatis, rårörda lingon, pressgurka och gräddsås  – 165 kr
         
          
          <h3>Portergryta</h3>
          på högrev, med vinbärsgele, potatis och sallad - 175 kr
         
          <h3>Räksoppa</h3>
          med handskalade räkor och halloumismörgås – 135 kr
       */}
          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr <br />
          Fetaost och spenat - 125 kr


          <h3>Räksmörgås</h3>
          Handskalade stora räkor på rågbröd – 159 kr

          {/*
          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr<br />

          
          <h3>Köttbullesmörgås</h3>
          på tekaka med rödbetssallad – 95 kr

          Rostbiff, potatis och remouladsås – 95 kr
        */}

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr
          <br />
          Chevré, valnötter och honung - 109 kr

          <h3>Lasagne</h3>
          Bolognese - 145 kr<br />

          {/*
           Vegetarisk – 145 kr
        */}

          <h3>Pannkakor</h3>
          med sylt och grädde, 2 eller 3 st. – 70/90 kr

        </>
      );
    },
  },
  {
    id: 3,
    namn: "påsk",
    mat: function () {
      return (
        <>
          <h3>Påsktallrik</h3>
          3 sorters sill, rökt lax, gubbröra, gräddfil med gräslök, ägghalvor, potatis, västerbottenostpaj, rågbröd, knäckebröd och smör – 175 kr

          <h3>Paj med sallad</h3>

          {/* Lax och spenat - 125 kr <br /> */}
          Fetaost och spenat - 125 kr

          <h3>Räksmörgås</h3>
          Handskalade stora räkor på rågbröd – 159 kr

          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr
          <br />
          Chevré, valnötter och honung - 109 kr

          <h3>Pannkakor</h3>
          med sylt och grädde, 2 eller 3 st. – 70/90 kr
          {/*
          <h3>Våffla </h3>
          med grädde och sylt – 65 kr
          */}

        </>
      );
    },
  },
  {
    id: 4,
    namn: "juli",
    mat: function () {
      return (
        <>
          <h3>Skärgårdstallrik</h3>Varmrökt lax, 3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök, färskpotatis, rågbröd, knäckebröd och smör – 225 kr

          <h3>Varmrökt lax med romsås</h3>färskpotatis och sallad – 219 kr

          <h3>Silltallrik</h3>3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök,
          ägg, färskpotatis, rågbröd, knäckebröd och smör – 159 kr

          {/*
          <h3>Räkssallad</h3>
          Handskalade lyxräkor, ägg, avokado och nobisdressing – 175 kr
          */}


          <h3>Paj med sallad</h3>
          Lax och spenat – 125 kr<br />
          Fetaost och spenat – 125 kr


          {/*
          <h3>Husets köttbullar</h3>
          med potatis, rårörda lingon, pressgurka och gräddsås  – 165 kr
          */}

          <h3>Lasagne med sallad</h3>
          Bolognese – 145 kr<br />
          Vegetarisk – 145 kr

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap – 105 kr<br />
          Chevré, valnötter och honung – 109 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
  },
  {
    id: 5,
    namn: "förenklad",
    mat: function () {
      return (
        <>
          <h3>Silltallrik</h3>3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök,
          ägg, färskpotatis, rågbröd, knäckebröd och smör – 159 kr

          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr
          <br />
          Fetaost och spenat - 125 kr

          <h3>Lasagne med sallad</h3>
          Bolognese – 145 kr<br />

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr
          <br />
          Chevré, valnötter och honung - 109 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 60/80 kr
        </>
      );
    },
  },
  {
    id: 6,
    namn: "ingenlax",
    mat: function () {
      return (
        <>
          <h3>Silltallrik</h3>3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök,
          ägg, färskpotatis, rågbröd, knäckebröd och smör – 159 kr

          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr
          <br />
          Fetaost och spenat - 125 kr

          <h3>Lasagne med sallad</h3>
          Bolognese – 145 kr<br />

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr
          <br />
          Chevré, valnötter och honung - 109 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
  },

  {
    id: 7,
    namn: "sensommar",
    mat: function () {
      return (
        <>

          {/*
         <h3>Kallrökt lax med dillstuvad potatis</h3> – 210 kr
          */}

          <h3>Husets köttbullar</h3>
          med potatis, rårörda lingon, pressgurka och gräddsås  – 165 kr

          <h3>Silltallrik</h3>3 sorters sill, gubbröra, västerbottenpaj, gräddfil med gräslök,
          ägg, färskpotatis, rågbröd, knäckebröd och smör – 159 kr


          {/*
          <h3>Paj med sallad</h3>
          Lax och spenat – 125 kr<br />
          Fetaost och spenat – 125 kr

         <h3>Lasagne med sallad</h3>
          Bolognese – 145 kr<br />
          */}

          {/* 
          
          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr
          */}

          {/*
         <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr
          */}

          <h3>Köttbullesmörgås</h3>
          på tekaka med rödbetssallad – 108 kr

          {/*
          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap – 105 kr<br />
          Chevré, valnötter och honung – 109 kr
          */}

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
  },

  {
    id: 8,
    namn: "höst",
    mat: function () {
      return (
        <>

          <h3>Portergryta</h3>
          på högrev, med vinbärsgele, potatis och sallad - 175 kr

          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr
          <br />
          Fetaost och spenat - 125 kr

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
  },

  {
    id: 9,
    namn: "jul",
    mat: function () {
      return (
        <>

          <h3>Jultallrik</h3>
          julskinka, kallrökt lax, 3 sorters sill, hovmästarsås, senap, rödbetssallad, gräddfil, gräslök, julost, potatis och vörtbröd - 155 kr.

          <h3>Paj med sallad</h3>
          Lax och spenat - 125 kr

          <h3>Grillsmörgås med sallad</h3>
          Ost och skinka med dijonsenap - 105 kr

          <h3>Smörrebröd</h3>
          Kallrökt lax med citronkräm – 99 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr
        </>
      );
    },
  },

  {
    id: 10,
    namn: "midsommar",
    mat: function () {
      return (
        <>

          <h3>Midsommartallrik</h3>
          3 sorters sill, varmrökt lax, räkröra, gräddfil, gräslök, kokt ägg, färskpotatis, smör och bröd - 245 kr

          <h3>Räksmörgås</h3>
          Handskalade lyxräkor på rågbröd – 159 kr

          <h3>Barnmeny</h3>
          Pannkakor med sylt och grädde, 2 eller 3 st. – 70/90 kr

          <h3>Jordgubbstårta</h3>
          Citronkrän, jordgubbsmousse, grädde och färska jordgubbar – 75kr
        </>
      );
    },
  },
];

const dagens = menyer.filter((obj) => obj.namn === "start")[0];

export default dagens;